<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import SupportSessionModalCreate from '../modals/SupportSessionModalCreate.vue'
  import SupportSessionModalEnd, {
    type ShowEndSupportSessionDialogParams
  } from '../modals/SupportSessionModalEnd.vue'
  import SupportSessionModalEndAssigned, {
    type ShowEndSupportSessionAssignedDialogParams
  } from '../modals/SupportSessionModalEndAssigned.vue'
  import SupportSessionModalDetails, {
    type ShowSupportSessionDetailsDialogParams
  } from '../modals/SupportSessionModalDetails.vue'
  import { type CreateSupportSessionFormProps } from '../forms/FormCreateSupportSession.vue'
  import { supportModalsKey } from './support-modals'

  // The session services are NOT created here — the surface mounting this
  // provider (SupportLayout, SettingsPanelSupport) provides them, so its
  // lists and these modals share the same datasource instances.

  const modalCreateSupportSessionRef = useTemplateRef(
    'modalCreateSupportSessionRef'
  )
  const modalEndSupportSessionRef = useTemplateRef('modalEndSupportSessionRef')
  const modalEndSupportSessionAssignedRef = useTemplateRef(
    'modalEndSupportSessionAssignedRef'
  )
  const modalSupportSessionDetailsRef = useTemplateRef(
    'modalSupportSessionDetailsRef'
  )

  const modals = {
    showCreateSupportSession: (params: CreateSupportSessionFormProps) => {
      modalCreateSupportSessionRef.value?.showModal(params)
    },
    showEndSupportSession: (params: ShowEndSupportSessionDialogParams) => {
      modalEndSupportSessionRef.value?.showModal(params)
    },
    showEndSupportSessionAssigned: (
      params: ShowEndSupportSessionAssignedDialogParams
    ) => {
      modalEndSupportSessionAssignedRef.value?.showModal(params)
    },
    showSupportSessionDetails: (
      params: ShowSupportSessionDetailsDialogParams
    ) => {
      modalSupportSessionDetailsRef.value?.showModal(params)
    }
  }

  provide(supportModalsKey, modals)

  defineExpose(modals)
</script>
<template>
  <slot />
  <SupportSessionModalCreate ref="modalCreateSupportSessionRef" />
  <SupportSessionModalEnd ref="modalEndSupportSessionRef" />
  <SupportSessionModalEndAssigned ref="modalEndSupportSessionAssignedRef" />
  <SupportSessionModalDetails ref="modalSupportSessionDetailsRef" />
</template>
